import { useEffect, useState } from 'react';

const NAV = [
  { label: '精选直达', href: '#featured' },
  { label: '分类合集', href: '#collections' },
  { label: '话题热榜', href: '#topics' },
  { label: '最新收录', href: '#updates' },
  { label: '收藏指引', href: '#tips' },
];

export default function MastheadHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-background-50'
      }`}
    >
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6 py-3">
        <a href="#featured" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-eye-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950">看料</span>
            <span className="mt-1 text-[10px] font-medium uppercase tracking-[0.22em] text-foreground-500">
              网址导航 · 地址汇总
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#tips"
          className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
        >
          <i className="ri-star-line text-base" />
          收藏本页
        </a>

        <button
          type="button"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          aria-label="打开菜单"
        >
          <i className="ri-menu-line text-lg" />
        </button>
      </div>
    </header>
  );
}